import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './workfuture.json';

const WorkFuture = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Future of work, automation, and remote work vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Work Future"
            image="/Images/future1.webp"
            seoTitle="Free English Lesson Plans: The Future of Work"
            seoDescription="Future of work, automation, and remote work vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default WorkFuture;


